import { CommonModule } from '@angular/common';
import {
  Component,
  OnInit,
} from '@angular/core';
import { SharedModule } from '../@commons/ui-components/shared.module';
import { ArticleComponent } from '../@commons/@components/article/article.component';
import { HeaderHomeComponent } from './@components/header-home/header-home.component';
import { fadeIn } from '../@commons/animations/animations';
import { Router } from '@angular/router';
import routesConstants from '../@commons/constants/routes.constants';
import { WeatherCardComponent } from './@components/weather-card/weather-card.component';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { TaskApi } from '@TheGreenHouseCompany/vegiwise-sdk-typescript/dist/sdk/location/task/task-api';
import { TaskListResponse } from '@TheGreenHouseCompany/vegiwise-sdk-typescript/dist/generated/@dto/responses/location/task-list.response';
import { StorageService } from '../@commons/@services/front/storage.service';
import { UserApi } from '@TheGreenHouseCompany/vegiwise-sdk-typescript/dist/sdk/user/user-api';
import { User } from '@TheGreenHouseCompany/vegiwise-sdk-typescript/dist/generated/@entities/app/user.entity';
import { CultivationApi } from '@TheGreenHouseCompany/vegiwise-sdk-typescript/dist/sdk/cultivation/cultivation-api';
import { WeatherApi } from '@TheGreenHouseCompany/vegiwise-sdk-typescript/dist/sdk/location/weather/weather-api';
import { MoonInfoCardComponent } from './@components/moon-info-card/moon-info-card.component';
import { AddressToUserApi } from '@TheGreenHouseCompany/vegiwise-sdk-typescript/dist/sdk/location/address-to-user/address-to-user-api';
import { UserResponse } from '@TheGreenHouseCompany/vegiwise-sdk-typescript/dist/generated/@dto/responses/user/user.response';
import { AddressToUserListResponse } from '@TheGreenHouseCompany/vegiwise-sdk-typescript/dist/generated/@dto/responses/location/address-to-user-list.response';
import { PagingResponse } from '@TheGreenHouseCompany/vegiwise-sdk-typescript/dist/generated/@dto/responses/pagination/paging.response';
import { HeaderPaddingSafeAreaComponent } from '../@commons/@components/header-padding-safe-area/header-padding-safe-area.component';
import { CultivationHierarchyApi } from '@TheGreenHouseCompany/vegiwise-sdk-typescript/dist/sdk/cultivation/cultivation-hierarchy/cultivation-hierarchy-api';
import { MyCultivationHierarchyListResponse } from '@TheGreenHouseCompany/vegiwise-sdk-typescript/dist/generated/@dto/responses/cultivation/my-cultivation-hierarchy-list.response';
import { UserHierarchiesComponent } from '../garden/user-hierarchies/user-hierarchies.component';
import { SkeletonLoaderComponent } from '../@commons/@components/loaders/skeleton-loader/skeleton-loader.component';
import { ArticleApi } from '@TheGreenHouseCompany/vegiwise-sdk-typescript/dist/sdk/article/article-api';
import {
  ArticleListRequest
} from '@TheGreenHouseCompany/vegiwise-sdk-typescript/dist/generated/@dto/requests/article/article-list.request';
import { FeedbackModalComponent } from '../@commons/@modals/feedback-modal/feedback-modal.component';
import { MessageCircleQuestionIconComponent } from '../@icons/message-circle-question-icon.component';
import { HexToHsl } from '../@commons/pipes/HexToHsl';
import { ChevronRightIconComponent } from '../@icons/chevron-right.component';
import { AlertsBannerComponent } from './@components/alerts-banner/alerts-banner.component';
import { PosthogService } from '../@commons/@services/front/posthog.service';
import { PlantApi } from '@TheGreenHouseCompany/vegiwise-sdk-typescript/dist/sdk/location/plant/plant-api';
import { PlantListRequest } from '@TheGreenHouseCompany/vegiwise-sdk-typescript/dist/generated/@dto/requests/location/plant-list.request';
import { GddMilestonesWidgetComponent, GddMilestoneItem } from './@components/gdd-milestones-widget/gdd-milestones-widget.component';

@Component({
  selector: 'vw-home', // Indicates that this component is standalone
  imports: [
    SharedModule,
    CommonModule,
    WeatherCardComponent,
    ArticleComponent,
    HeaderHomeComponent,
    TranslateModule,
    MoonInfoCardComponent,
    HeaderPaddingSafeAreaComponent,
    UserHierarchiesComponent,
    SkeletonLoaderComponent,
    FeedbackModalComponent,
    MessageCircleQuestionIconComponent,
    HexToHsl,
    ChevronRightIconComponent,
    AlertsBannerComponent,
    GddMilestonesWidgetComponent,
  ], // Imports shared and common modules
  templateUrl: './home.component.html', // Path to the component's template
  styleUrls: ['./home.component.scss'], // Path to the component's styles
  animations: [fadeIn],
  providers: [
    {
      provide: ArticleApi,
      useClass: ArticleApi,
    },
    {
      provide: TaskApi,
      useClass: TaskApi,
    },
    {
      provide: UserApi,
      useClass: UserApi,
    },
    {
      provide: CultivationApi,
      useClass: CultivationApi,
    },
    {
      provide: CultivationHierarchyApi,
      useClass: CultivationHierarchyApi,
    },
    {
      provide: WeatherApi,
      useClass: WeatherApi,
    },
    {
      provide: AddressToUserApi,
      useClass: AddressToUserApi,
    },
    {
      provide: PlantApi,
      useClass: PlantApi,
    },
  ]
})
export class HomeComponent implements OnInit {
  tasks: TaskListResponse[] = []; // Array to hold tasks
  isModalOpen: boolean = false; // State variable to manage modal visibility
  hierarchies: MyCultivationHierarchyListResponse[] = []; // Array to hold the list of plants
  articles: any[] = []; // Array to hold badge information
  gddMilestones: GddMilestoneItem[] = []; // In-progress plants with GDD/thermal status
  user: User;
  userAddressUid: string;
  userLoaded: boolean = false;
  isLoading: boolean = true;
  isFeedbackModalOpen: boolean = false;

  // Example data for the cards
  /*cards = [
    {
      label: '19°c',
      imageUrl: '/assets/svg/cloud-rain-colored.svg',
      title: 'Pas besoin d’arroser aujourd’hui',
      tailwindClasses: 'bg-[#E1EDFE]',
      timeLabelStyle: 'text-[#0F453B]',
      expanded: false,
      weatherImg: '/assets/svg/weather-tree.svg',
      WeatherForecastLabel: 'text-[#1A4166]',
    },
    {
      label: '19°c',
      imageUrl: '/assets/svg/cloud-rain-white.svg',
      title: 'Pas besoin d’arroser aujourd’hui',
      tailwindClasses: 'bg-[#205280]',
      timeLabelStyle: 'text-[#FFFFFFB2]',
      expanded: false,
      weatherImg: '/assets/svg/weather-tree.svg',
      WeatherForecastLabel: 'text-[#FFFFFF]',
    },
    {
      label: '24°c',
      imageUrl: '/assets/svg/sun-white.svg',
      title: 'Pas besoin d’arroser aujourd’hui',
      tailwindClasses: 'bg-[#F4D537]',
      timeLabelStyle: 'text-[#FFFFFFB2]',
      expanded: false,
      weatherImg: '/assets/svg/weather-tree.svg',
      WeatherForecastLabel: 'text-[#FFFFFF]',
    },
    {
      label: '24°c',
      imageUrl: '/assets/svg/sun.svg',
      title: 'Pas besoin d’arroser aujourd’hui',
      tailwindClasses: 'bg-[#F49F37]',
      timeLabelStyle: 'text-[#0F453B]',
      expanded: false,
      weatherImg: '/assets/svg/weather-tree.svg',
      WeatherForecastLabel: 'text-[#1A4166]',
    },
    {
      label: 'Dernier Quartier ',
      imageUrl: '/assets/svg/moon.svg',
      title: 'Ne pas jardiner',
      tailwindClasses: 'bg-[#382E96]',
      timeLabelStyle: 'text-[#DAF2E0]',
      expanded: false,
      weatherImg: '/assets/svg/moon-tree.svg',
      WeatherForecastLabel: 'text-[#FFFFFF]',
    },
  ];*/

  constructor(
    private router: Router,
    private taskApi: TaskApi,
    private userApi: UserApi,
    private addressToUserApi: AddressToUserApi,
    private cultivationApi: CultivationApi,
    private cultivationHierarchyApi: CultivationHierarchyApi,
    private storageService: StorageService,
    private translate: TranslateService,
    private weatherApi: WeatherApi,
    private articleApi: ArticleApi,
    private posthogService: PosthogService,
    private plantApi: PlantApi,
  ) { }

  async ngOnInit() {
    try {
      this.loadTasks();
      await this.loadUser();
      this.loadGddMilestones(); // fire-and-forget: needs the address (set by loadUser), must not block home render
      await this.loadUserCultivations();
      const articles = await this.articleApi.list(new ArticleListRequest(), 1, 20, this.storageService.getCurrentLanguage());
      this.articles = articles.results;
    } catch (e) {
      console.error('HomeComponent: failed to initialize', e);
    } finally {
      this.isLoading = false;
    }
  }

  loadTasks() {
    const taskFilters: TaskListResponse = new TaskListResponse();
    return this.taskApi
      .list(taskFilters, 0, 10, this.storageService.getCurrentLanguage())
      .then((TaskPaging) => {
        if (TaskPaging) {
          this.tasks.push(...TaskPaging.results);
        }
      })
      .catch((e) => console.error('HomeComponent: failed to load tasks', e));
  }

  async loadUser() {
    const userResponse: UserResponse = await this.userApi.getCurrentUser();
    this.user = userResponse;
    const addressToUserPaging: PagingResponse<AddressToUserListResponse> =
      await this.addressToUserApi.list(
        {
          userUid: userResponse.uid,
        },
        0,
        10,
        this.storageService.getCurrentLanguage()
      );
    if (addressToUserPaging.results.length > 0) {
      this.userAddressUid = addressToUserPaging.results[0].addressUid;
      this.userApi.addUserAddressUid(this.userAddressUid);
    }

    if (this.user && this.user.preferredLanguage) {
      this.storageService.setCurrentLang(
        this.user.preferredLanguage.toUpperCase()
      );
      this.translate.use(this.user.preferredLanguage.toLowerCase());
    }
    this.userLoaded = true;
    this.posthogService.identify(userResponse.uid, {
      language: this.user.preferredLanguage,
    });
  }

  async loadUserCultivations() {
    this.hierarchies = await this.cultivationHierarchyApi.myGarden(
      this.storageService.getCurrentLanguage()
    );
  }

  /**
   * Loads the user's in-progress plants and maps them to GDD milestone items.
   * Best-effort: a failure must not break the home page (widget self-hides when empty).
   */
  async loadGddMilestones() {
    try {
      const lang = this.storageService.getCurrentLanguage();
      const plantsPaging = await this.plantApi.list(new PlantListRequest(), 0, 50, lang);
      this.gddMilestones = (plantsPaging.results || [])
        .filter((p) => !!p.currentGrowingStep)
        .map((p): GddMilestoneItem => ({
          plantUid: p.uid,
          // cultivationUid is now serialized on the variant; the nested object
          // is kept as a fallback for older cached payloads
          cultivationUid: p.cultivationVariant?.cultivationUid ?? p.cultivationVariant?.cultivation?.uid,
          variantUid: p.cultivationVariant?.uid,
          cultivationName: this.resolveLabel(p.cultivationVariant?.name),
          variantName: this.resolveLabel(p.cultivationVariant?.name),
          locationName: p.location?.name,
          currentStepName: this.resolveLabel(p.currentGrowingStep?.name),
          progress: p.currentGrowingStepProgression ?? 0,
          estimatedDaysLeft: p.thermalProgress?.estimatedDaysLeft ?? null,
          conditionBadge: p.thermalProgress?.conditionBadge ?? 'NORMAL',
        }));
    } catch (e) {
      console.error('HomeComponent: failed to load GDD milestones', e);
    }
  }

  /** Resolves a backend label (already a string when a lang is passed, else a LabelDto) to a display string. */
  private resolveLabel(label: any): string {
    if (!label) return '';
    return typeof label === 'string' ? label : (label.fr ?? '');
  }

  /**
   * Emits a profile click event to the parent component.
   */
  onProfileClick() {
    this.router.navigate([routesConstants.PROFILE]);
  }

  /**
   * Opens the modal by setting isModalOpen to true.
   */
  openModal() {
    this.isModalOpen = true; // Open the modal
  }

  /**
   * Closes the modal by setting isModalOpen to false.
   */
  closeModal() {
    this.isModalOpen = false; // Close the modal
  }

  /**
   * Logs a message when the modal is closed and invokes closeModal.
   */
  onModalClose() {
    this.closeModal(); // Close the modal
  }

  /**
   * Logs a confirmation message and closes the modal.
   */
  confirmAction() {
    this.closeModal(); // Close the modal
  }

  // Card click event handler
  onWeatherCardClicked() { }

  // Card click event handler
  onMoonCardClicked() { }

  onFeedbackClicked() {
    this.router.navigate([routesConstants.FEEDBACK]);
  }

  onNotificationsClicked() {
    this.router.navigate([routesConstants.NOTIFICATIONS]);
  }

  onAddPlant() {
    this.router.navigate([routesConstants.GARDEN_ADDPLANT]);
  }
}
